import React, { FC, forwardRef } from "react";
import { Control } from "react-hook-form";

import CheckBoxBase, { CheckBoxProps } from "@/components/ui/Form/CheckBox/CheckBoxBase";
import CheckboxControlled from "@/components/ui/Form/CheckBox/CheckboxControlled";

import "./checkbox.css";

interface DynamicInputProps extends CheckBoxProps {
  control?: Control<any>;
}

const CheckBox = forwardRef<HTMLInputElement, DynamicInputProps>((args, ref) => {
  return <>{args?.control ? <CheckboxControlled control={args.control} {...args} /> : <CheckBoxBase {...args} />}</>;
});
CheckBox.displayName = "CheckBox";
export default CheckBox;
